import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { ServicosService } from './Service';
const service = new ServicosService();

interface ServicosContextProps {
    data: any[];
    loading: boolean;
    error: boolean;
    reloadData: () => Promise<void>;
}

const ServicosContext = createContext<ServicosContextProps | undefined>(undefined);

export const useServicosContext = () => {
    const context = useContext(ServicosContext);
    if (!context) {
        throw new Error('useServicosContext must be used within a UsersProvider');
    }
    return context;
};

export const ServicosProvider = ({ children }: { children: ReactNode }) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const reloadData = async () => {
        setLoading(true);
        setError(false);
        try {
            const result = await service.findAll().then((r) => r?.data || []);
            setData(result);
        } catch (error) {
            console.error('Error fetching Servicos:', error);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        reloadData();
    }, []);

    return (
        <ServicosContext.Provider value={{ data, reloadData, loading, error }}>
            {children}
        </ServicosContext.Provider>
    );
};